import { createContext, useContext } from 'react';

type UserProcStepContextType = {
  stepId?: string;
};

export const UserProcStepContext = createContext<UserProcStepContextType>(
  {} as UserProcStepContextType,
);

export const useUserProcStepContext = () => useContext(UserProcStepContext);
